import { FetchModelResponse } from '@cian/http-api';
import {
  fetchCreateUpcomingSaleRequest,
  TCreateUpcomingSaleRequestRequest,
  TCreateUpcomingSaleRequestResponse,
} from '../../../shared/repositories/newbuilding-flat-view-order/v1/create-upcoming-sale-request';
import { getNewbuildingId, getRegionId } from '../../../shared/selectors/newbuilding';

import { IErrorResponseSchema } from '../../../shared/repositories/newbuilding-flat-view-order/entities/schemas/ErrorResponseSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../shared/types/redux';

type ICreateUpcomingSaleRequestParams = Pick<TCreateUpcomingSaleRequestRequest, 'phone' | 'userName' | 'email'>;

export const createUpcomingSaleRequest = createAsyncThunk<void, ICreateUpcomingSaleRequestParams, IThunkApi>(
  'upcomingSale/createRequest',
  async (params, thunkApi) => {
    const {
      getState,
      extra: { httpApi, logger },
    } = thunkApi;
    try {
      const newbuildingId = getNewbuildingId(getState());
      const regionId = getRegionId(getState());

      const response: TCreateUpcomingSaleRequestResponse = await fetchCreateUpcomingSaleRequest({
        httpApi,
        parameters: {
          ...params,
          newbuildingId,
          regionId: regionId as number,
        },
        config: {
          requestConfig: {
            headers: [['Content-Type', 'application/json']],
          },
        },
      });

      if (![200, 204].includes(response.statusCode)) {
        throw (response as FetchModelResponse<400, 'json', IErrorResponseSchema>).response.message;
      }
    } catch (error) {
      logger.error(error, {
        domain: 'createUpcomingSaleRequest',
      });
      throw error;
    }
  },
);
